// TradeHistory/constants.js

export const COLORS = {
  primary: '#00d4ff',
  success: '#10b981',
  danger: '#ef4444',
  warning: '#f59e0b',
  purple: '#8b5cf6',
  pink: '#ec4899',
  bg: {
    primary: '#0a0e13',
    secondary: '#111827',
    tertiary: '#1f2937',
    card: 'rgba(17, 24, 39, 0.8)',
  },
  text: {
    primary: '#ffffff',
    secondary: 'rgba(255, 255, 255, 0.7)',
    muted: 'rgba(255, 255, 255, 0.4)',
  },
  border: 'rgba(255, 255, 255, 0.08)',
};

export const formatDateTime = (dateStr) => {
  if (!dateStr) return '—';
  return dateStr.replace('T', ' ').replace('Z', '').replace(/\+00:?00$/, '').split('.')[0];
};

export const formatPrice = (price) => {
  if (price === null || price === undefined) return '—';
  return `$${Number(price).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const formatPnL = (value, showSign = true) => {
  if (value === null || value === undefined) return '—';
  const num = Number(value);
  const sign = showSign ? (num >= 0 ? '+' : '') : '';
  return `${sign}$${Math.abs(num).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const formatPercent = (value, showSign = true) => {
  if (value === null || value === undefined) return '—';
  const num = Number(value);
  const sign = showSign ? (num >= 0 ? '+' : '') : '';
  return `${sign}${num.toFixed(2)}%`;
};

export const formatDuration = (entryTime, exitTime) => {
  if (!entryTime || !exitTime) return '—';
  try {
    const entry = new Date(entryTime);
    const exit = new Date(exitTime);
    const diffMs = exit - entry;
    const diffMins = Math.floor(diffMs / 60000);
    const hours = Math.floor(diffMins / 60);
    const mins = diffMins % 60;
    if (hours > 0) return `${hours}h ${mins}m`;
    return `${mins}m`;
  } catch {
    return '—';
  }
};

export const formatShortDate = (dateStr) => {
  if (!dateStr) return '';
  try {
    const date = new Date(dateStr);
    return `${date.getMonth() + 1}/${date.getDate()}`;
  } catch {
    return '';
  }
};

export const calculateTimeDiff = (time1, time2) => {
  if (!time1 || !time2) return null;
  try {
    const diffMs = Math.abs(new Date(time2) - new Date(time1));
    const diffSecs = Math.floor(diffMs / 1000);
    const mins = Math.floor(diffSecs / 60);
    const secs = diffSecs % 60;
    return mins > 0 ? `${mins}m ${secs}s` : `${secs}s`;
  } catch {
    return null;
  }
};
